module.exports = __webpack_public_path__ + "static/media/galerija_2019 (27).403375b7.jpg";